import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';
import {UserPage} from '../../model/pagination/user/user-page.model';

@Injectable()
export class UsersCustomerResolver implements Resolve<Observable<UserPage>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(): Observable<UserPage> {
    return this.facadeService.getPageUsersCustomers(0, 5).pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
